"use strict";
import React from "react";
import _ from "underscore";
import generalFormatter from "../../formatters/general";
import SimpleHtmlFormat from "../simple_html_format";
import EmailLabelEditor from "../email_label_editor";
import WaitingSpinner from "../../components/waiting_spinner";
var EmailViewer = React.createClass({
  getInitialState() {
    return {
      updating: false
    };
  },
  render: function() {
    const message = this.props.message;
    const wasAutomaticallySentAfterIndexing = !!message.automatically_sent_after_indexing;
    const containerClass = message.message_type === "sent" ? "email-viewer__container--sent" : "";
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { "data-component": "EmailViewer", when: this.state.updating }, /* @__PURE__ */ React.createElement("div", { className: "email-viewer__container " + containerClass }, /* @__PURE__ */ React.createElement("div", { className: "email-viewer__title" }, message.message_type === "sent" ? "Sent" : "Received", " Message", " ", wasAutomaticallySentAfterIndexing ? "(Automatic)" : ""), /* @__PURE__ */ React.createElement("div", { className: "email-viewer__email highlighted" }, /* @__PURE__ */ React.createElement("div", { className: "email-viewer__header" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line activity-item__primary-details" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, "Subject"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, message.subject)), /* @__PURE__ */ React.createElement("div", { className: "activity-item__secondary-details" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label activity-item__detail-line-label__from" }, "From"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, message.sender_address)), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label activity-item__detail-line-label__recipient" }, "Recipient"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, message.recipient_address)), this.possibleAdditionalRecipients(), this.possibleCc(), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, "Received"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, generalFormatter.dateTime(message.created_at)))), this.possibleDocumentFromEmailLink(), this.possibleEmailLabelEditor(), this.possibleAttachments()), /* @__PURE__ */ React.createElement("div", { className: "email-viewer__body" }, /* @__PURE__ */ React.createElement(SimpleHtmlFormat, { text: message.text_body })))));
  },
  possibleDocumentFromEmailLink: function() {
    if (this.props.message.message_type !== "sent" && this.props.documentFromEmail) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "email-viewer__save-button button--confirmation",
          onClick: this.documentFromEmail
        },
        "Save As Document"
      );
    }
  },
  documentFromEmail: function() {
    this._withUpdate(
      this.props.documentFromEmail(this.props.message),
      this.props.documentFromEmailCallback
    );
  },
  _withUpdate: function(promise, callback) {
    this.setState({ updating: true });
    promise.then((a) => {
      this.setState({ updating: false });
      if (callback) {
        callback(a);
      }
    }).catch(() => {
      this.setState({ updating: false });
      return {};
    });
  },
  possibleEmailLabelEditor: function() {
    if (this.props.message.message_type !== "sent") {
      return /* @__PURE__ */ React.createElement(EmailLabelEditor, { email: this.props.message });
    }
  },
  possibleAdditionalRecipients: function() {
    if (this.props.message.to && !_.isEmpty(this.props.message.to)) {
      const additionalRecipients = _.rest(this.props.message.to);
      if (!_.isEmpty(additionalRecipients)) {
        const recipients = _.map(additionalRecipients, function(address) {
          return address.email;
        });
        return this.recipientsView(recipients, "Additional recipients");
      }
    }
  },
  recipientsView: function(recipients, label) {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, label), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, recipients.join(", ")));
  },
  possibleCc: function() {
    if (this.props.message.cc && !_.isEmpty(this.props.message.cc)) {
      const recipients = _.map(this.props.message.cc, function(address) {
        return address.email;
      });
      return this.recipientsView(recipients, "CC");
    }
  },
  possibleAttachments: function() {
    var attachments = this.props.message.downloadable_attachments || [];
    if (attachments.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line email-viewer__attachments" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, "Attachments"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, _.map(attachments, this.attachment)));
    }
  },
  failureMessage: function() {
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "email-viewer__attachment-failed has-tip",
        title: "Attachment could not be processed. Contact the sender for a replacement"
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-alert" })
    );
  },
  attachment: function(attachment) {
    const message = attachment.caused_by_failure ? this.failureMessage() : null;
    return /* @__PURE__ */ React.createElement("li", { key: attachment.url, className: "email-viewer__attachment" }, /* @__PURE__ */ React.createElement("span", { className: "email-viewer__attachment-name" }, /* @__PURE__ */ React.createElement("a", { target: "_blank", href: attachment.url }, attachment.name), message));
  }
});
export default EmailViewer;
